var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19581 10.5607C10.1476 9.93038 10.848 8.98604 11.175 7.89229C11.5019 6.79853 11.4347 5.62472 10.9849 4.57548C10.5351 3.52623 9.73144 2.66809 8.71387 2.15065C7.6963 1.63321 6.52941 1.48929 5.41661 1.74396M9.19581 10.5607V8.66484M9.19581 10.5607H11.1041M3.79161 2.44434C2.8431 3.07695 2.14631 4.02201 1.82243 5.11516C1.49855 6.2083 1.56805 7.38039 2.01885 8.42761C2.46965 9.47482 3.27323 10.3309 4.28986 10.847C5.30648 11.3631 6.47184 11.5065 7.58327 11.2524M3.79161 2.44434V4.33151M3.79161 2.44434H1.89577",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStatus);
export default __webpack_public_path__ + "static/media/changeStatus.b058dcc4a7c348dd9ec0236a2109de1a.svg";
export { ForwardRef as ReactComponent };